import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOutgoingMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#999"
        d="m15.062 15.704-.766-.767 1.367-1.395h-3.455v-1.084h3.455l-1.367-1.396.766-.765L17.703 13zM3.548 13.792a1.3 1.3 0 0 1-.946-.394 1.3 1.3 0 0 1-.394-.946V4.548q0-.553.394-.946a1.3 1.3 0 0 1 .946-.394h9.895q.568 0 .958.394t.39.946l.021 3.628a.7.7 0 0 0 .209.032 8 8 0 0 0-.677.07 5 5 0 0 0-.636.136V5.06L8.5 8.744 3.292 5.053v7.399a.25.25 0 0 0 .072.184.25.25 0 0 0 .184.072h6.657a1 1 0 0 0 0 .104q.003.075.003.188 0 .156.034.396.033.24.06.396zm.553-9.5L8.5 7.444l4.415-3.152z"
      />
    </g>
  </svg>
);
export default SvgOutgoingMail;
